var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiltersVertical = function SvgFiltersVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 6.5V4H7.6V6.5H6.4ZM11.4 16.5V4H12.6V16.5H11.4ZM16.4 14.5V4H17.6V14.5H16.4ZM5 8.4H9V9.6H7.6V20H6.4V9.6H5V8.4ZM15 16.4H19V17.6H17.6V20H16.4V17.6H15V16.4ZM10 18.4H14V19.6H10V18.4Z"
  })));
};
export default SvgFiltersVertical;